export default __webpack_public_path__ + "school.3c9136b.png";